import { createAction, props } from '@ngrx/store';
import { TimeZones } from 'generated/graphql-types';

export const selectAccount = createAction(
   '[Select Account] Account Select',
   props<{
      accountName: string | null;
      accountId: number | null;
      accountShortName: string | null;
      timeZoneId: TimeZones | null;
   }>()
);

export const accountIdChange = createAction('[Select Account] Account Id Change');

export const accountRoutingChange = createAction('[Select Account] Account Route Changed');

export const selectedAccountLoaded = createAction(
   '[Select Account] Selected Account Loaded',
   props<{
      accountName: string | null;
      accountId: number | null;
      accountShortName: string | null;
      timeZoneId: TimeZones | null;
   }>()
);

export const selectedAccountLoadedOnLogin = createAction(
   '[Select Account] Selected Account Loaded on Login',
   props<{
      accountName: string | null;
      accountId: number | null;
      accountShortName: string | null;
      isSystemUser: boolean;
      timeZoneId: TimeZones | null;
   }>()
);
